interface CustomWindow extends Window {
  dataLayer: any[]
}
declare let window: CustomWindow

export interface BasicDataLayerEvent {
  button_type?: string
  button_text?: string
  button_url?: string
  button_src?: string
  button_section?: string
  button_prev_section?: string
  button_next_section?: string
  button_sectionId?: string
  button_prev_sectionId?: string
  button_next_sectionId?: string
  form_name?: string
  form_url?: string
  calculator_type?: string
  calculator_value?: string
  calculator_value_from?: string
  click_text?: string
  popup_view?: string
  cookies_category?: string
  cookies_button_placement?: string
}

export function pushDataLayer(eventName: string, eventParams: BasicDataLayerEvent): void {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  })
}
